import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { WorkflowCollectionModel } from '../../Models/Domains/Workflow/WorkflowCollectionModel';
import { IJsonDate } from '../../System/IJsonDate';
import { SubAccountType } from '../../Constants/Enums/Domain/SubAccountType';
import { ProcessType } from '../../Constants/Enums/Client/DashboardFilter/ProcessType';
import { ActivityStatus } from '../../Constants/Enums/Client/DashboardFilter/ActivityStatus';

declare var IS_RUNNING_IN_APP_POOL;

export class InstructionWorkflowClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(startDate: IJsonDate, endDate: IJsonDate, adviserIds: Array<number>, product: SubAccountType, activityType: ProcessType, status: ActivityStatus, companyCode: string, network: string, start: number, count: number, headAccountHierarchyIds: Array<string>, subAccountHierarchyIds: Array<string>, customerId: number): Promise<WorkflowCollectionModel, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Instruction/InstructionWorkflow/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { startDate: startDate, endDate: endDate, adviserIds: adviserIds, product: product, activityType: activityType, status: status, companyCode: companyCode, network: network, start: start, count: count, headAccountHierarchyIds: headAccountHierarchyIds, subAccountHierarchyIds: subAccountHierarchyIds, customerId: customerId }

    return AjaxWrapper.get<WorkflowCollectionModel, any>(url, data);
  }
}

